import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { createSetter } from 'shared/redux-helpers'

interface BottomItem {
	id: number
	image: string
	link: string
	title: string
}

interface ListItem {
	id: string
	name: string
}

interface Slice {
	active: null | number
	leftSide: {
		bottomList: BottomItem[]
		label?: string
		list?: any[]
		type:
			| ''
			| 'account'
			| 'campaign'
			| 'contacts'
			| 'messaging'
			| 'team'
			| 'upgrade'
	}
}

const initialState: Slice = {
	active: null,
	leftSide: {
		bottomList: [],
		label: '',
		list: [],
		type: ''
	}
}

const leftSideSlice = createSlice({
	initialState,
	name: 'leftSideMenu',
	reducers: {
		setActive: createSetter<Slice>('active'),
		setLeftSide: createSetter<Slice>('leftSide'),

		updateListName(state, action: PayloadAction<ListItem>) {
			const { id, name } = action.payload
			const found = state.leftSide.list?.find(item => item.id === id)

			if (found) {
				found.name = name
			}
		}
	},
	selectors: {
		active: state => state.active,
		// @ts-ignore I guess should be contacts
		isContact: state => state.leftSide.type === 'contact'
	}
})

const leftSideActions = leftSideSlice.actions,
	leftSideSelectors = leftSideSlice.selectors

export type LeftMenuType = LeftSide['type']
export type LeftSide = Slice['leftSide']

export { leftSideActions, leftSideSelectors, leftSideSlice }
